import { CollectionsNavigation } from '@/types/collections-navigation';

// Excluded default categories
const STORE_COLLECTION_EXCLUDED_SLUGS = ['accessories', 'apparel', 'homeware', 'Drinkware'];

// As there is a conflict with the default categories, and custom collections this temp route is used
export const buildCustomCollectionRoute = (slug: string) => {
  return `/collection/${slug}`;
};

export const applyNavigationOverrides = (collectionsNavigation: CollectionsNavigation): CollectionsNavigation => {
  const exploreItem = collectionsNavigation.collections.find((collection) => collection.name === 'Explore');

  // Define store categories
  const storeCollections = collectionsNavigation.collections.filter(
    (collection) => collection.collections && collection.collections.length > 0 && collection.name !== 'Explore'
  );

  // Define custom collections
  const customCollections = collectionsNavigation.collections.filter(
    (collection) => (!collection.collections || collection.collections.length === 0) && collection.name !== 'Explore'
  );

  // Get all custom collection slugs to check for conflicts
  const customCollectionSlugs = new Set(customCollections.map((collection) => collection.slug));

  // Apply the store collection exclusions and filter out any that conflict with custom collections
  const modifiedStoreCollections = storeCollections.filter(
    (collection) =>
      !STORE_COLLECTION_EXCLUDED_SLUGS.includes(collection.slug || '') && !customCollectionSlugs.has(collection.slug)
  );

  const modifiedCustomCollections = customCollections.map((collection) => ({
    ...collection,
    url: buildCustomCollectionRoute(collection.slug || ''),
  }));

  // Compose all collections for ordering
  let allCollections = [
    ...(exploreItem ? [exploreItem] : []),
    ...modifiedStoreCollections,
    ...modifiedCustomCollections,
  ];

  // Custom forced order (after Explore):
  const forcedOrder = ['apparel', 'drinkware', 'accessories', 'creators', 'collabs'];

  // Remove 'Explore' from the list for ordering (already at front)
  allCollections = allCollections.filter((col) => col.name?.toLowerCase() !== 'explore');

  // Build forced items in order
  const orderedForcedItems = forcedOrder
    .map((forcedName) => allCollections.find((item) => item.name?.toLowerCase().trim() === forcedName))
    .filter(Boolean) as typeof allCollections;
  // All other items not in forced order
  const forcedNamesSet = new Set(forcedOrder);
  const otherItems = allCollections.filter((item) => !forcedNamesSet.has(item.name?.toLowerCase().trim() || ''));

  // Sort the rest alphabetically (case-insensitive)
  otherItems.sort((a, b) => (a.name?.toLowerCase() || '').localeCompare(b.name?.toLowerCase() || ''));

  // Combine all
  const finalCollections = [...(exploreItem ? [exploreItem] : []), ...orderedForcedItems, ...otherItems];

  return {
    ...collectionsNavigation,
    collections: finalCollections,
  };
};
